import { RouterConfig } from '@angular/router';
import { AccountComponent } from './account.component';
import { EmailConfirmationComponent } from './email-confirmation.component';
import { AuthGuard } from '../authentication/auth-guard.service';


export const AccountRoutes: RouterConfig = [
  { path: 'account', component: AccountComponent, canActivate: [AuthGuard]  },
  { path: 'email-confirmation', component: EmailConfirmationComponent },
  //{ path: 'email-confirmation/:email/:code', component:  EmailConfirmationComponent }
];




/** WEBPACK FOOTER **
 ** ./app/accounts/account.routes.ts
 **/